<template>
  <NsProductCardBase
    v-if="hasContent"
    :disable-add-to-adr="disableAddToAdr"
    :disable-add-to-cart="disableAddToCart"
    :disable-quantity-selector="disableQuantitySelector"
    :exclusive-offer-message="exclusiveOfferMessage"
    :forcesv="forcesv"
    :hide-exclusive-icon="hideExclusiveIcon"
    :hide-exclusive-text-on-mobile="hideExclusiveTextOnMobile"
    :hide-favorites="hideFavorites"
    :hide-sku="hideSku"
    :image-fallback-src="imageFallbackSrc"
    :image="image"
    :image-set="imageSet"
    :is-base-sku="isBaseSku"
    :is-distributor="isDistributor"
    :is-exclusive="isExclusive"
    :is-favorite="isFavorite"
    :is-logged-in="isLoggedIn"
    :is-loyalty-enabled="isLoyaltyEnabled"
    :is-sale="isSale"
    :loyalty-status-and-links="loyaltyStatusAndLinks"
    :market-attributes="marketAttributes"
    :max-quantity="maxQuantity"
    :min-price="minPrice"
    :max-price="maxPrice"
    :no-action="noAction"
    :original-price="originalPrice"
    :points="points"
    :price="price"
    :quantity="quantity"
    :sales-label="salesLabel"
    :show-exclusive-offer-message="showExclusiveOfferMessage"
    :show-original-crossed-out="showOriginalCrossedOut"
    :show-variant-selector="showVariantSelector"
    :sku="activeSku"
    :status-message="statusMessage"
    :status-message-key="statusMessageKey"
    :title="title"
    :translations="localTranslations"
    :user-is-qualified="userIsQualified"
    :user-loyalty="userLoyalty"
    :variants="variants"
    :variant-skus="variantSkus"
    @variant-select="handleVariantSelect"
    @quantity-select="handleQuantitySelect"
    @add-to-cart="handleAddToCart"
    @add-to-adr="handleAddToAdr"
    @card-click="handleCardClick"
    @favorite-click="handleFavoriteClick"
  />
</template>

<script>
import NsProductCardBase from "./NsProductCardBase.vue";
import NsProductMixin from "../mixins/NsProductMixin.js";

/**
 * NsProductCard
 *
 * How to use: Any variables used in the template that are not props in this
 * component come from the mixin.
 *
 * @event variant-select  When a variant selection occurs, this event emits a
 * function with params: (value, index)
 * @event product-update  When a product updates, this event emits a function
 * with params: (product)
 * @event card-click  When clicking on the ProductCard, this event emits a
 * function with params: (product). If listener is NOT assigned, clicking the
 * card will go to the product detail page
 */

export default {
  name: "NsProductCard",
  components: {
    NsProductCardBase
  },
  mixins: [NsProductMixin],
  props: {
    /**
     * Always show the sv value
     */
    forcesv: Boolean,
    /**
     * Hides the Exclusive Icon
     */
    hideExclusiveIcon: Boolean,
    /**
     * Hides Exclusive Text only on mobile
     */
    hideExclusiveTextOnMobile: Boolean,
    /**
     * Hides the Favorites Icon
     */
    hideFavorites: Boolean,
    /**
     * Hides the Sku number
     */
    hideSku: Boolean,
    /**
     * Won't show the Action area on hover
     */
    noAction: Boolean
  },
  data() {
    return {
      referrer: "productCard"
    };
  }
};
</script>
